var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition-group",
    {
      attrs: {
        name: "custom-classes-transition",
        "enter-active-class": "animated slideInLeft",
        "leave-active-class": "animated slideOutLeft",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.toggleSideMenu,
              expression: "toggleSideMenu",
            },
          ],
          key: "tile-parent",
          staticClass: "tile is-parent",
          style: { "min-width": _vm.inlineStyle },
        },
        [
          _c(
            "article",
            {
              key: "tile-child",
              staticClass: "tile is-child box",
              style: { "min-width": _vm.inlineStyle },
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.$user.info.isSupportUser &&
                        _vm.hasFlexiShopIntegration,
                      expression:
                        "$user.info.isSupportUser && hasFlexiShopIntegration",
                    },
                  ],
                  staticClass: "icon is-synced-icon",
                  class: [
                    _vm.isSynced ? "has-text-success" : "has-text-warning",
                  ],
                },
                [_c("i", { staticClass: "mdi mdi-circle-medium mdi-36px" })]
              ),
              _vm.bookings && _vm.bookings.length > 0
                ? _c("div", { staticClass: "tabs" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.bookings, function (booking) {
                        return _c(
                          "li",
                          {
                            key: booking.key,
                            class: {
                              "is-active": booking.key === _vm.currentBooking,
                            },
                          },
                          [
                            _c(
                              "router-link",
                              {
                                class: {
                                  "is-disabled":
                                    _vm.isNew &&
                                    booking.key !== _vm.currentBooking,
                                },
                                attrs: {
                                  to: {
                                    name: _vm.currentRouteName,
                                    params: { bookingId: booking.value },
                                    query: _vm.$route.query,
                                  },
                                  "active-class": "is-active",
                                  exact: "",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.goToRoute({
                                      name: _vm.currentRouteName,
                                      params: { bookingId: booking.value },
                                      query: _vm.$route.query,
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "has-badge-warning has-badge-small has-badge-rounded has-badge-offset2":
                                        _vm.isNew &&
                                        booking.key === _vm.currentBooking,
                                    },
                                    attrs: {
                                      "data-badge":
                                        _vm.isNew &&
                                        booking.key === _vm.currentBooking
                                          ? ""
                                          : null,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          booking.key === 0
                                            ? "Main"
                                            : `Add-${booking.key}`
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._t("side-menu"),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }